import { WorksheetImagesAndRemarksSection, WorksheetRootComponent } from 'Components/Worksheets/Core';
import { withInjectedProps } from '../../Core/InjectedPropsContext';
import { PageSection } from '../../Layout';
import qestIds from '../QestIds';
import { SoilSamplingDetailsSection } from './Sections';

let SoilSamplingCertificate: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Sampling Details">
        <SoilSamplingDetailsSection />
      </PageSection>

      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

SoilSamplingCertificate = withInjectedProps(SoilSamplingCertificate);
SoilSamplingCertificate.qestIds = [qestIds.samplingCertificate.BS_5930_Rev2015];

export default SoilSamplingCertificate;
export { SoilSamplingCertificate };
